import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, projectname, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";

function CategoriesList() {
  const con = {
    headers: {
      ContentType: 'application/json',
      Authorization: "Bearer " + localStorage.getItem("njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras"),
    },
  };
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();

  const [articles, setArticles] = useState([]);
  const [loading, setloading] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getArticles();
    const interval = setInterval(() => {
      getArticles();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const getArticles = () => {
    axios.get(URL_API + "auth/admin/category", con).then((response) => {
      if (response?.data?.status === 200) {
        setArticles(response.data.categories);
        setLoadMoreAds(response?.data?.categories)
      }
    });
  };

  const destroyArticle = (id) => {
    handleShow();

    axios
      .post(URL_API + `auth/admin/category-delete/${id}`, '', con)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/categories");
          toast.success("Category Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getArticles();
        }
      });
  };

  const initialPostList = 10 // Number of loadMoreAds to display initially
  const incrementInitialPostList = 10 // Number of loadMoreAds to add each time the "load more" button is clicked
  const [displayPosts, setDisplayPosts] = React.useState(initialPostList)
  const [loadMoreAds, setLoadMoreAds] = React.useState()
  const loadMore = () => {
    setDisplayPosts(displayPosts + incrementInitialPostList)
  }



  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">{projectname} | <i class="fa fa-home" aria-hidden="true"></i> | Category</CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <Link to={`/admin/category/create`}>
                  <strong>Add Category + </strong>
                </Link>
              </div>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      {/* <th>Category</th> */}
                      <th>F.Image</th>
                      <th>D.Image</th>
                      <th>D.Image 2</th>
                      <th>FAQs</th>
                      {/* <th>Meta Title</th>
                      <th>Meta Descrption</th>
                      <th>Keywords</th> */}
                      <th>Created At</th>
                      <th>Action</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      // loading ? (
                      //   <div>
                      //     <BeatLoader
                      //       css={loaderCss}
                      //       size="12"
                      //       color="#4cd964"

                      //       loading
                      //     />
                      //     <br />
                      //     <br />
                      //   </div>
                      // ) : (
                      loadMoreAds?.slice(0, displayPosts)?.map(
                        (article, index) => {
                          return (
                            <tr >
                              <td>{index + 1}</td>
                              <td>{article?.title}</td>
                              {/* <td>{article?.category?.title}</td> */}
                              <td width={120}>
                                <img
                                  height="40px"
                                  width="80px"
                                  src={IMAGE_URL + article?.image}
                                />
                              </td>
                              <td width={120}>
                                <img
                                  height="40px"
                                  width="80px"
                                  src={IMAGE_URL + article?.description_image}
                                />
                              </td>
                              <td width={120}>
                                <img
                                  height="40px"
                                  width="80px"
                                  src={IMAGE_URL + article?.description_image2}
                                />
                              </td>
                              <td className="faq-style">
                                {article?.faq?.map((tg, index) => {
                                  return <> <span className="faq-section">{index + 1}. {tg.name} </span>  <br /></>;
                                })}
                              </td>
                              {/* <td width="30">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: `${article?.article_text?.substring(
                                      0,
                                      50
                                    )}`,
                                  }}
                                />
                              </td> */}


                              {/* <td>{article?.meta_title}</td>
                              <td>{article?.meta_description}</td>
                              <td>{article?.keywords}</td> */}
                              <td>
                                {moment(article?.created_at).format(
                                  " DD MMMM,YYYY"
                                )}
                              </td>
                              <td>
                                <Link to={`/admin/category/edit/${article.id}`}>
                                  <i class="far fa-edit fa-lg"></i>
                                </Link>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a
                                  style={{ color: "red" }}
                                  onClick={() => destroyArticle(article.id)}
                                >
                                  <i class="fas fa-trash-alt fa-lg"></i>
                                </a>
                              </td>
                            </tr>
                          );
                        }
                        // )
                      )
                    }
                  </tbody>
                </Table>
                {displayPosts < loadMoreAds?.length ? (
                  <div className="container" style={{ textAlign: "center", marginTop: '30px', padding: '10px' }}>
                    <div className="row" >
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="btn-default-section">
                          <button className="btn btn-secondary" onClick={loadMore} style={{ padding: '15px' }}>
                            Load More
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default CategoriesList;
